import React, { useEffect } from "react";
import AboutPageHeading from "./AboutPageHeading";
import img1 from "../../assets/AboutUs/Group 1700.png";
import ellipse from "../../assets/AboutUs/Ellipse 68.svg";
import Aos from "aos";

export const Section2 = () => {
  return (
    <div className="w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
      {/* <h2
        data-aos="fade-up"
        className="text-center w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
      >
        R.A.T FILMS
      </h2> */}

      <h2
        data-aos="fade-up"
        className="text-center w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
      >
        R.A.T FILMS
      </h2>

      <p
        data-aos="fade-up"
        className="font-montserrat text-center text-[!16px] sm:text-[20px] 3xl-plus:text-[30px] text-white mt-8 font-normal"
      >
        Welcome to R.A.T Films, where each motion picture, from advertising
        commercials to feature films and web series, is crafted as a unique
        cinematic experience. We believe in storytelling that captivates and
        sparks conversations, with every film carrying its own distinct voice
        and visual magic. Driven by a commitment to quality, we bring together
        the best talent in the industry to deliver Start-to-Finish solutions. At
        R.A.T Films, we're dedicated to creating powerful, unforgettable stories
        that set new standards in the art of filmmaking.
      </p>
    </div>
  );
};

// md:pr-[4.58vw] md:pl-[6.77vw]  md:gap-x-[6.25vw]  md:pb-[12.04vh] md:pt-[8.33vh]

export default Section2;
